import { CurrentAppUrl } from "@hornet-web-react/core/types/session"

export const getEmberAppUrl = (currentAppUrl: CurrentAppUrl) =>
  currentAppUrl.replace("next.", "")
